import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/JeffHersh.jpg";

const JeffHBio = (props) => {
  const bioData = {
    title: "Jeff Hersh",
    title2: "Independent Director",
    hashName: "jeff-hersh",
    bio1: `Jeff Hersh has served as an independent director of the Company since April 2021. He is also a general practitioner attorney licensed to practice in New York and Connecticut. Since 2009, Mr. Hersh has handled complex legal issues across multiple jurisdictions across New York and Connecticut. His primary focus areas include contracts and transactional work & litigation matters. He also has served as in-house counsel for VMP Holdings LLC, a family office located in Larchmont, NY since January 2016. Managing general legal affairs, consulting on a variety of real estate-based transactions, and analyzing investment opportunities, he provides candid and practical legal analysis on a broad spectrum of issues from the perspective of a seasoned attorney and counselor, including issues related to the acquisition and management of digital assets. That same legal experience bolsters his role in internal business and strategy decisions, helping to mitigate legal and financial risk. In certain company matters, Mr. Hersh will coordinate with outside counsel to assist the management team in the resolution of any issues.`,
    bio2: `Whether structuring and negotiating a contract, contemplating a business decision, or auditing a financial investment opportunity, he relies on deep knowledge base to take an aggressive and skillful approach to problem solving while strongly advocating for his clients. Mr. Hersh acquired a law degree from Ave Maria School of Law in Ann Arbor, Michigan, where he participated in the Trial Advocacy Program. He also holds a bachelor’s degree in political science from Rollins College in Winter Park, Florida, where he served on the Executive Committee of the Student Government Association.`,
    bio3: `Mr. Hersh is a valuable of our board of directors because of his experience in advising on investments and real-estate-based transactions.`,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      bio2={bioData.bio2}
      bio3={bioData.bio3}
      closeBio={props.closeBio}
    />
  );
};

export default JeffHBio;
